export default __webpack_public_path__ + "static/media/coffe2.6d519e5c.webp";